import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authAPI } from "../services/api";
import { useI18n } from "../i18n";
import AuthShell, { buttonClass, inputClass } from "../components/AuthShell";

/** Where the link in a reset email lands. */
const ResetPassword = () => {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");

    if (password !== confirm) {
      setError(t("auth.reset.mismatch"));
      return;
    }

    setBusy(true);
    try {
      await authAPI.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      const status = err.response?.status;
      // Too short or the default is the person's to fix; anything else is the link
      setError(
        status === 400 && /password/i.test(err.response.data?.message || "")
          ? err.response.data.message
          : t("auth.reset.invalid"),
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("auth.reset.title")}>
      {!token ? (
        <p className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          {t("auth.reset.missing")}
        </p>
      ) : done ? (
        <div className="space-y-5">
          <p className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm">
            {t("auth.reset.done")}
          </p>
          <Link to="/login" className={`${buttonClass} block text-center`}>
            {t("auth.reset.signIn")}
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          {error && (
            <p className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </p>
          )}

          <div>
            <label htmlFor="reset-1" className="block text-sm font-medium text-gray-700 mb-2">
              {t("auth.reset.password")}
            </label>
            <input id="reset-1"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
              className={inputClass}
            />
            <p className="mt-1 text-xs text-gray-500">{t("auth.reset.hint")}</p>
          </div>

          <div>
            <label htmlFor="reset-2" className="block text-sm font-medium text-gray-700 mb-2">
              {t("auth.reset.confirm")}
            </label>
            <input id="reset-2"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              required
              className={inputClass}
            />
          </div>

          <button type="submit" disabled={busy} className={buttonClass}>
            {busy ? t("auth.reset.saving") : t("auth.reset.submit")}
          </button>
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPassword;
